export const shouldFetchAutocorrection: (query: string) => boolean = (query: string) => {
	return query.length >= 4;
};
